import React from "react";
import PropTypes from "prop-types";
import {
  Popover,
  Box,
  Typography,
  Button,
  makeStyles,
} from "@material-ui/core";
import { Warning as WarningIcon } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  popover: {
    padding: theme.spacing(2.5),
    maxWidth: 360,
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  warningIcon: {
    color: theme.palette.warning.main,
    fontSize: 24,
  },
  title: {
    fontWeight: 600,
    fontSize: "1.1rem",
  },
  folderName: {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  warning: {
    color: theme.palette.error.main,
    fontSize: "0.85rem",
    marginTop: theme.spacing(1),
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  deleteButton: {
    backgroundColor: theme.palette.error.main,
    color: "white",
    "&:hover": {
      backgroundColor: theme.palette.error.dark,
    },
  },
}));

const FolderDeleteConfirmDialog = ({
  open,
  anchorEl,
  folderName,
  onConfirm,
  onCancel,
}) => {
  const classes = useStyles();
  const { t } = useTranslation("translation", {
    keyPrefix: "rgm.cockpit.scenario_manager.folder_delete",
  });

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onCancel}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      transformOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Box className={classes.popover}>
        <Box className={classes.header}>
          <WarningIcon className={classes.warningIcon} />
          <Typography className={classes.title}>{t("title")}</Typography>
        </Box>

        <Typography variant="body2">
          {t("confirm_message")}{" "}
          <span className={classes.folderName}>&quot;{folderName}&quot;</span>?
        </Typography>

        <Typography className={classes.warning}>{t("warning")}</Typography>

        <Box className={classes.actions}>
          <Button onClick={onCancel}>{t("cancel")}</Button>
          <Button
            variant="contained"
            className={classes.deleteButton}
            onClick={onConfirm}
          >
            {t("delete")}
          </Button>
        </Box>
      </Box>
    </Popover>
  );
};

FolderDeleteConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  folderName: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default FolderDeleteConfirmDialog;
